import { render, staticRenderFns } from "./EventPersonalization.vue?vue&type=template&id=649a2bcc&scoped=true"
import script from "./EventPersonalization.vue?vue&type=script&lang=js"
export * from "./EventPersonalization.vue?vue&type=script&lang=js"
import style0 from "./EventPersonalization.vue?vue&type=style&index=0&id=649a2bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a2bcc",
  null
  
)

export default component.exports